import type { JSX } from 'react';
import { TextArea } from '../../../../_components/TextField.js';
import type { Palette } from '../../../../_theme/palette.js';
import type { SurveyQuestion } from '../../types.js';

interface LongTextFieldProps {
  palette: Palette;
  question: SurveyQuestion;
  value: unknown;
  onChange: (value: unknown) => void;
}

export function LongTextField({ palette, question, value, onChange }: LongTextFieldProps): JSX.Element {
  return (
    <TextArea
      palette={palette}
      value={typeof value === 'string' ? value : ''}
      onChange={onChange}
      placeholder={question.settings?.placeholder ?? ''}
      rows={4}
      maxLength={question.settings?.maxLength}
    />
  );
}
